/*
 * @Description:
 * @Author: fal
 * @Date: 2025-08-11 15:31:32
 * @FilePath: \xhlz_pc\src\project\components\data.js
 * @LastEditTime: 2025-08-16 14:33:02
 */
export const highlightMap = {
  '/personMag/index': [
    '/personMag/index/hire',
    '/personMag/index/updateHire',
    '/personMag/index/viewHire',
    '/personMag/index/company',
    '/personMag/index/people',
    '/personMag/index/project',
    '/personMag/index/joblist',
    '/personMag/index/resume',
    '/personMag/index/updateResume',
    '/personMag/index/viewResume',
  ],
  '/personMag/profile': ['/personMag/profile/edit', '/personMag/profile/cert'],
  '/personMag/procedure': [
    '/personMag/procedure/matters',
    '/personMag/procedure/remRcd',
    '/personMag/procedure/remDetail',
    '/personMag/procedure/paymentRcd',
    '/personMag/procedure/paymentDetail',
    '/personMag/procedure/paymentConfirmation',
  ],
  '/personMag/infoMag/laborDemand': ['/personMag/infoMag/laborDemand', '/personMag/infoMag/laborQuoteList'],
  '/personMag/infoMag/material': ['/personMag/infoMag/material', '/personMag/infoMag/materialQuoteList'],
  '/personMag/infoMag/machine': ['/personMag/infoMag/machine', '/personMag/infoMag/machineQuoteList'],
  '/personMag/infoMag/comprehensive': ['/personMag/infoMag/comprehensive', '/personMag/infoMag/comprehensiveQuoteList'],

  '/supplier/profile/index': ['/supplier/profile/edit', '/supplier/profile/cert'],
  '/supplier/procedure': ['/supplier/procedure/project'],
  '/supplier/goodsMag': ['/supplier/goodsMag/update'],
  '/supplier/infoMag/hire': ['/supplier/infoMag/updateHire'],
  '/supplier/infoMag/laborDemand': ['/supplier/infoMag/laborQuoteList'],
  '/supplier/infoMag/material': ['/supplier/infoMag/materialQuoteList'],
  '/supplier/infoMag/machine': ['/supplier/infoMag/machineQuoteList'],
  '/supplier/infoMag/comprehensive': ['/supplier/infoMag/comprehensiveQuoteList'],

  '/project/infoMag/laborDemand': ['/project/infoMag/laborQuoteList'],
  '/project/infoMag/material': ['/project/infoMag/materialQuoteList'],
  '/project/infoMag/machine': ['/project/infoMag/machineQuoteList'],
  '/project/infoMag/comprehensive': ['/project/infoMag/comprehensiveQuoteList'],
  '/project/material/stuff': ['/project/material/stuffDetail', '/project/material/rentalStuffDetail', '/project/material/stuffPayList'],
  '/project/material/machine': ['/project/material/machineDetail', '/project/material/machinePayList'],
  '/project/prime/costSummary?type=2': ['/project/prime/costList'],
  '/project/prime/amount': ['/project/prime/quantityList', '/project/prime/mngCostList', '/project/prime/taxCostList', '/project/prime/taxDetailsList'],
  '/project/warn/process': ['/project/warn/processRecord'],
  '/project/warn/cost': ['/project/warn/clearRecord', '/project/warn/countRecord'],
  '/project/warn/person': ['/project/warn/personRecord'],
  '/project/warn/material': ['/project/warn/materialRecord'],
  '/project/warn/machine': ['/project/warn/machineRecord'],
  '/project/contract/depart': ['/project/contract/departPay'],
  '/project/contract/material': ['/project/contract/materialPay'],
  '/project/contract/machine': ['/project/contract/machinePay'],

  '/doer/profile/index': ['/doer/profile/edit', '/doer/profile/cert'],
  '/doer/infoMag/hire': ['/doer/infoMag/updateHire'],
  '/doer/infoMag/laborDemand': ['/doer/infoMag/laborQuoteList'],
  '/doer/infoMag/material': ['/doer/infoMag/materialQuoteList'],
  '/doer/infoMag/machine': ['/doer/infoMag/machineQuoteList'],
  '/doer/infoMag/comprehensive': ['/doer/infoMag/comprehensiveQuoteList'],
  '/doer/procedure': ['/doer/procedure/details'],
  '/doer/material': ['/doer/material/approvalRecord'],
  '/doer/contract': ['/doer/contract/depart', '/doer/contract/material', '/doer/contract/machine', '/doer/contract/tax'],
  '/doer/cert': ['/doer/cert/person'],
};
